import { render } from "./SlideTwo.vue?vue&type=template&id=72244bcf&scoped=true"
import script from "./SlideTwo.vue?vue&type=script&lang=js"
export * from "./SlideTwo.vue?vue&type=script&lang=js"

import "./SlideTwo.vue?vue&type=style&index=0&id=72244bcf&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72244bcf"]])

export default __exports__